"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.match");

require("core-js/modules/es.string.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getFieldIDByIndex = function getFieldIDByIndex(field, sectionID, fieldID) {
  // If SectionID does not contain array index [] then it is just a regular field
  if (sectionID.indexOf('[]') === -1) {
    return "".concat(sectionID, "__").concat(fieldID);
  } // SectionID has array index [] - first extract array index
  // Find the index of array using field.id field
  // Index is between `-`


  var matches = field.id.match(/-(\d*)-/);
  var index = matches.length > 1 ? matches[1] : 0;
  return "".concat(sectionID.replace('[]', ''), "[").concat(index, "].").concat(fieldID);
};

var mandatoryWhenNot = function mandatoryWhenNot(field, ruleData, form) {
  if (ruleData.hasOwnProperty('and')) {
    return ruleData.and.reduce(function (acc, currentValue) {
      return acc && mandatoryWhenNot(field, currentValue, form);
    }, true);
  }

  if (ruleData.hasOwnProperty('or')) {
    return ruleData.or.reduce(function (acc, currentValue) {
      return acc || mandatoryWhenNot(field, currentValue, form);
    }, false);
  }

  var targetValue;

  try {
    var query = ruleData.sectionID ? getFieldIDByIndex(field, ruleData.sectionID, ruleData.id) : ruleData.id;
    targetValue = form.$(query).value;
  } catch (e) {
    targetValue = null;
  }

  return targetValue !== ruleData.value;
};

var _default = mandatoryWhenNot;
exports.default = _default;
//# sourceMappingURL=mandatoryWhenNot.js.map